import React, { FC } from 'react';
import { Notification } from 'common/components';
import { AuthHooks } from 'common/hooks';
import { useAppSelector } from 'app/store/store.hooks';
import { selectCurrentUser } from 'entities/User/User.slice';
import { selectXBasketId } from 'entities/Auth/Auth.slice';
import { getIsSelfRegistered } from 'entities/Account/Account.helper';
import { IBasket } from 'entities/Basket/Basket.models';
import { getBasketDeliveryType } from 'entities/Basket/Basket.helper';

interface IComponentProps {
  basket: IBasket | null;
  isLimitExceeded: boolean;
  errors: string[];
}

export const BasketNotifications: FC<IComponentProps> = ({ basket, isLimitExceeded, errors }) => {
  // auth
  const xBasketId = useAppSelector(selectXBasketId);
  // user
  const currentUser = useAppSelector(selectCurrentUser);

  const { isSeller } = AuthHooks.useIsSeller();

  const isCurrentBasket = currentUser?.basketId === basket?.id || xBasketId === basket?.id;
  const isSelfRegistered = getIsSelfRegistered(basket?.account);
  const { isDelivery } = getBasketDeliveryType(basket);

  return (
    <>
      {!isSeller && isLimitExceeded && isCurrentBasket && (
        <div className="mb-4">
          <Notification
            type="error"
            title="Ваш заказ превышает доступный лимит на покупки"
            description="Сократите количество товаров в списке или замените их на позиции с более низкой ценой."
          />
        </div>
      )}

      {!isSeller &&
        isSelfRegistered &&
        errors.map((item, index) => {
          return (
            <div key={index} className="mb-4">
              <Notification type="warning" description={item} />
            </div>
          );
        })}

      {!isSeller && isDelivery && (
        <div className="mb-4">
          <Notification
            type="success"
            description="После оформления менеджер свяжется с вами для подтверждения даты и времени доставки"
          />
        </div>
      )}
    </>
  );
};
